import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// types
import { AppStateType } from './appTypes';

// ==============================|| APP SLICE ||============================== //

const initialState: AppStateType = {
  menu: {
    selectedItem: ['dispatcher'],
    selectedID: null,
    drawerOpen: true
  },
  snackbar: {
    action: false,
    open: false,
    message: '',
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    variant: 'default',
    alert: {
      color: 'info',
      variant: 'filled'
    },
    transition: 'Fade',
    close: true,
    actionButton: false,
    autoHideDuration: 6000
  },
  ajaxLoader: 0,
  appErrorId: undefined
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    openSnackbar: (state, action: PayloadAction<any>) => {
      const {
        open,
        message,
        anchorOrigin,
        variant,
        alert,
        transition,
        close,
        actionButton,
        autoHideDuration
      } = action.payload;

      state.snackbar = {
        action: !state.snackbar.action,
        open: open || initialState.snackbar.open,
        message: message || initialState.snackbar.message,
        anchorOrigin: anchorOrigin || initialState.snackbar.anchorOrigin,
        variant: variant || initialState.snackbar.variant,
        alert: {
          color: alert?.color || initialState.snackbar.alert.color,
          variant: alert?.variant || initialState.snackbar.alert.variant
        },
        transition: transition || initialState.snackbar.transition,
        close: close === false ? close : initialState.snackbar.close,
        actionButton: actionButton || initialState.snackbar.actionButton,
        autoHideDuration:
          !autoHideDuration && typeof autoHideDuration === 'object'
            ? null
            : initialState.snackbar.autoHideDuration
      };
    },
    openDrawer: (state, action: PayloadAction<any>) => {
      state.menu.drawerOpen = action.payload;
    },
    setActiveItem: (state, action: PayloadAction<any>) => {
      state.menu.selectedItem = action.payload;
    },
    setActiveID: (state, action: PayloadAction<any>) => {
      state.menu.selectedID = action.payload;
    },
    setAjaxLoader: (state, action: PayloadAction<boolean>) => {
      state.ajaxLoader = action.payload
        ? state.ajaxLoader + 1
        : state.ajaxLoader - 1;
    },
    setAppErrorId: (state, action: PayloadAction<string | undefined>) => {
      state.appErrorId = action.payload;
    }
  }
});

export const {
  openSnackbar,
  openDrawer,
  setActiveItem,
  setActiveID,
  setAjaxLoader,
  setAppErrorId
} = appSlice.actions;

export const app = appSlice.reducer;
